import React, { useContext } from "react";
import PropTypes from "prop-types";
import SimpleTextFieldMUI from "./SimpleTextFieldMUI";
import SimplePasswordFieldMUI from "./SimplePasswordFieldMUI";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
//import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
//import styles from "./styles/CredentialsViewComponent.module.css";
//import "@fontsource/roboto/500.css";
import { CredsContext } from "./Contexts";
import "./styles/CredentialsViewComponent.css";

function CredentialsViewComponent(props) {
  const creds = useContext(CredsContext).creds;
  //const boxSize = props.boxSize;
  let boxSize = "normal";
  if (props.boxSize == "large") {
    boxSize = "large";
  }

  return (
    <Table
      sx={{
        padding: "1px",
        border: "none",
      }}
    >
      {boxSize == "large" ? (
        <TableHead>
          <TableRow>
            <TableCell sx={{ opacity: 0, border: "none" }}></TableCell>
          </TableRow>
        </TableHead>
      ) : (
        <TableHead sx={{ backgroundColor: "black" }}>
          <TableRow data-size={boxSize} className="credentialsHeaderRow">
            <TableCell
              className="credentialsHeader"
              data-size={boxSize}
              colSpan="2"
              style={{
                textAlign: "center",
                color: "white",
              }}
              sx={{ padding: "1px !important" }}
            >
              <Typography>Credentials</Typography>
            </TableCell>
          </TableRow>
        </TableHead>
      )}
      <TableBody>
        <TableRow className="credentialsRow" data-size={boxSize}>
          <TableCell
            colSpan="2"
            data-size={boxSize}
            className="globaloptionslabelcentered"
            style={{
              textAlign: "center",
              border: "none",
            }}
          >
            <input
              type="radio"
              id="sandbox"
              name="instance"
              value="Sandbox"
              onChange={props.radioChangeHandler}
              checked={creds.instanceType === "Sandbox"}
            />
            <label
              htmlFor="sandbox"
              style={{ fontFamily: "Roboto", textTransform: "uppercase" }}
            >
              Sandbox
            </label>
            &nbsp;&nbsp;
            <input
              type="radio"
              id="prod"
              name="instance"
              value="Production"
              onChange={props.radioChangeHandler}
              checked={creds.instanceType === "Production"}
            />
            <label
              htmlFor="prod"
              style={{ fontFamily: "Roboto", textTransform: "uppercase" }}
            >
              Production
            </label>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell data-size={boxSize} className="globaloptionslabel">
            Company
          </TableCell>
          <TableCell data-size={boxSize} className="globaloptionsfield">
            <SimpleTextFieldMUI
              id="companyField"
              value={
                creds.orig_company == "Leanswift Solutions Inc"
                  ? "Genericomp"
                  : creds.orig_company
              }
              onChange={props.inputChangeHandler}
              sx={{ zIndex: 1 }}
              handleKeyPress={props.handleKeyPress}
            />
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell data-size={boxSize} className="globaloptionslabel">
            Username
          </TableCell>
          <TableCell data-size={boxSize} className="globaloptionsfield">
            <SimpleTextFieldMUI
              id="usernameField"
              value={creds.orig_username}
              onChange={props.inputChangeHandler}
              handleKeyPress={props.handleKeyPress}
            />
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell data-size={boxSize} className="globaloptionslabel">
            Password
          </TableCell>
          <TableCell data-size={boxSize} className="globaloptionsfield">
            <SimplePasswordFieldMUI
              id="passwordField"
              value={creds.password}
              onChange={props.inputChangeHandler}
              handleKeyPress={props.handleKeyPress}
            />
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
}

export default CredentialsViewComponent;

CredentialsViewComponent.propTypes = {
  inputChangeHandler: PropTypes.func,
  radioChangeHandler: PropTypes.func,
  handleKeyPress: PropTypes.func,
  boxSize: PropTypes.string,
};
